
/**
 * Creado por dexter
 * @author JaimeCastillo <jaime22acc@gmail.com>
 * @Date 25/01/2022
 */
const listRequest = () => {
    return {
        field_id: null,
        stage_id: null,
        query: null,
    }

}

export default listRequest;